import { AxiosInstance } from "axios";
export default (httpClient: AxiosInstance) => ({
    getDinamico: async (pUrl: string) => {
        const response = await httpClient.get(pUrl);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    postDinamicoLink: async (pUrl: string) => {

        const response = await httpClient.post(pUrl);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    postDinamico: async (pUrl: string, dado: object, pGenerator: number | null) => {
        if (pGenerator != null) {
            // @ts-expect-error : unreachable code
            dado.id = pGenerator;
        }
        const response = await httpClient.post(pUrl, dado);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    postExcluir: async (pUrl: string) => {
        const response = await httpClient.post(pUrl);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Generator: async (pGenerator: string) => {
        const response = await httpClient.get(`/Relatorio/generator?sequence=SEQ_${pGenerator}_ID`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    listaOrdenada: async (pTabela: string, pAtributo: string, pOrdem: string) => {
        const response = await httpClient.get(`/${pTabela}/listar?orderBy=${pAtributo} ${pOrdem}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
});